// src/js/components/smartComparison.js

export function initializeSmartComparison() {
    const wrapper = document.getElementById('smart-comparison');
    // Avbryt om komponenten inte finns på sidan
    if (!wrapper) {
        return;
    }

    const table = wrapper.querySelector('.comparison-table-desktop');
    const mobileViewWrapper = wrapper.querySelector('.mobile-view-wrapper');

    if (!table || !mobileViewWrapper) {
        return;
    }

    // Privat funktion för att bygga mobilvyn
    function buildMobileView() {
        const captionText = table.querySelector('caption') ? table.querySelector('caption').textContent : '';
        const headers = Array.from(table.querySelectorAll('thead th')).map(th => th.innerHTML);
        const rows = Array.from(table.querySelectorAll('tbody tr'));
        const data = rows.map(row => Array.from(row.querySelectorAll('th, td')).map(cell => cell.innerHTML));

        let infographicHTML = `<div class="comparison-infographic">`;
        if (captionText) {
            infographicHTML += `<div class="comparison-caption">${captionText}</div>`;
        }
        infographicHTML += `<div class="infographic-grid">`;
        infographicHTML += `<div class="grid-header product-package">${headers[1]}</div>`;
        infographicHTML += `<div class="grid-header customized-project">${headers[2]}</div>`;
        data.forEach(rowData => {
            infographicHTML += `<h3 class="attribute-group-header">${rowData[0]}</h3>`;
            infographicHTML += `<div class="value-box">${rowData[1]}</div>`;
            infographicHTML += `<div class="value-box">${rowData[2]}</div>`;
        });
        infographicHTML += `</div></div>`;
        mobileViewWrapper.innerHTML = infographicHTML;
    }

    // Privat funktion för tooltips
    function initializeTooltips() {
        const tooltipContainers = wrapper.querySelectorAll('.tooltip-container');
        tooltipContainers.forEach(container => {
            const trigger = container.querySelector('.info-trigger');
            if(trigger) {
                trigger.addEventListener('click', (e) => {
                    e.preventDefault();
                    // Stäng andra aktiva tooltips
                    tooltipContainers.forEach(c => {
                        if (c !== container) {
                            c.classList.remove('tooltip-active');
                        }
                    });
                    // Växla den klickade
                    container.classList.toggle('tooltip-active');
                });
            }
        });

        // Stäng alla tooltips vid klick utanför
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.tooltip-container')) {
                tooltipContainers.forEach(c => c.classList.remove('tooltip-active'));
            }
        });
    }

    buildMobileView();
    initializeTooltips();
    console.log('Smart Comparison initialized.');
}